import dayjs from 'utils/dayjs';

// Set to October 30th, 2022
export const TERMS_OF_SERVICE_REQUIRED_DATE = dayjs('2022-10-30');
